module.exports = __webpack_public_path__ + "img/bag-timer.fa6b36f6.svg";